module.exports = __webpack_public_path__ + "school/img/development.373ad606.png";